import { PropsWithRootStore } from 'constants/types'
import { FC } from 'react'
import { Main } from 'layouts'
import { inject, observer } from 'mobx-react'
import { PriceManager } from 'prices'
import { LegalWrapper } from 'components/LegalWrapper'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'

const TermsAndConditions: FC<PropsWithRootStore> = (props) => {
	const currency = props.rootStore.priceStore.currency
	const settings = props.rootStore.settingsStore.settings
	const coverAmount = props.rootStore.priceStore.coverDiscountNumber
	const mattressAmount = props.rootStore.priceStore.podDiscountNumber
	const regionSellsBundle = props.rootStore.productStore.regionSellsBundle()

	return (
		<Main>
			<LegalWrapper
				mainTitle="Sale Terms and Conditions"
				heroSrc="https://eightsleep.imgix.net/assets/sales_terms_hero.jpg"
				includeContact={false}
			>
				<h2>Sale: Online Only.</h2>
				<p>
					{PriceManager.formatPriceToCurrencyNoDecimal(coverAmount, currency)} off the full price Pod Cover
					{regionSellsBundle
						? ` and an additional ${PriceManager.formatPriceToCurrencyNoDecimal(
								mattressAmount,
								currency
						  )} off the 5-layer mattress (US only). 20% off accessories only with a purchase of the Pod Cover.`
						: '.'}
				</p>

				<p>{regionSellsBundle ? settings.checkoutLegalese : settings.checkoutLegalese.split('.')[0]}</p>

				<p>No price matches or adjustments. Cannot be combined with any other promo code. Offer may be modified or discounted at any time without notice.</p>
			</LegalWrapper>
			<ScrollSequenceStatic />
		</Main>
	)
}

export default inject('rootStore')(observer(TermsAndConditions))
